import { render, staticRenderFns } from "./ClipDialogMessage.vue?vue&type=template&id=6171c838"
import script from "./ClipDialogMessage.vue?vue&type=script&lang=js"
export * from "./ClipDialogMessage.vue?vue&type=script&lang=js"
import style0 from "./ClipDialogMessage.vue?vue&type=style&index=0&id=6171c838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
